import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BsFillQuestionCircleFill } from 'react-icons/bs';
import { OverlayTriggerType } from 'react-bootstrap/esm/OverlayTrigger';
import { GenericObject } from 'v2/models';

export interface QuestionMarkToolTipProps {
  styles: GenericObject;
  helpText?: string;
  trigger?: OverlayTriggerType;
  disabled?: boolean;
}

const QuestionMarkToolTip = ({
  styles,
  helpText,
  trigger,
  disabled = false,
}: QuestionMarkToolTipProps) => {
  return (
    <OverlayTrigger
      placement="top"
      trigger={trigger ? trigger : undefined}
      overlay={
        <Tooltip id={`tooltip`} className={styles.tooltip}>
          {helpText}
        </Tooltip>
      }
    >
      <Button
        variant="secondary"
        className="p-0 m-0 border-0 bg-transparent ml-2"
        data-testid="tooltip"
        disabled={disabled}
      >
        <BsFillQuestionCircleFill className={styles.helpIcon} />
      </Button>
    </OverlayTrigger>
  );
};

export default QuestionMarkToolTip;
